<template>
  <div>
    <!-- 退换货编辑 || 返件单号编辑：-->
    <el-dialog :title="$t('message.productReturnAndExchange')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1432px" center >
      <div class="content">
        <!-- 类型 -->
        <div class="type">
          <!-- 退换货类别： -->
          <span>{{ $t("message.typeOfReturnOrExchange") }}:</span>
          <el-select v-model="val" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="table">
          <ol>
            <!--编号  -->
            <li class="flex05">{{ $t("message.serialNumber") }}</li>
            <!-- 交易号 -->
            <li class="flex15">{{ $t("message.transactionNumber") }}</li>
            <!--店铺信息  -->
            <li>{{ $t("message.storeInformation") }}</li>
            <!--照片  -->
            <li>{{ $t("message.pic") }}</li>
            <!--商品属性  -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--上架可能数  -->
            <li>{{ $t("message.possibleNumberOfShelves") }}</li>
            <!--退换货数量  -->
            <li>{{ $t("message.quantityOfReturnAndReplacement") }}</li>
            <!-- 物流号 -->
            <li class="flex3">
              {{ $t("message.logisticsNumber") }}
            </li>
            <!-- 操作 -->
            <li>{{ $t("message.operation") }}</li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <!--编号  -->
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 交易号 -->
            <li class="flex15">{{ item.purchase_no }}</li>
            <!--店铺信息  -->
            <li>
              <div class="template">
                <p>{{ item.shop_name }}</p>
                <p style="color: #15ad3c">
                  {{ item.from_platform }}
                </p>
                <p>{{ item.shop_id }}</p>
              </div>
            </li>
            <!--照片  -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!--商品属性  -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--上架可能数  -->
            <li>{{ item.possible_num }}</li>
            <!--退换货数量  -->
            <li>
              <el-input v-model="item.num"></el-input>
            </li>
            <!-- 物流号 -->
            <li class="flex3">
              <div class="template">
                <div class="row" v-for="(items, indexs
                    ) in item.order_purchase_refund_detail_express" :key="indexs">
                  <el-input v-model="items.refund_express_no" :placeholder="$t('message.logisticsNumber')"></el-input>
                  <!-- 删除 -->
                  <el-button size="mini" type="primary" class="dark" @click="delItem(index, indexs)">
                    {{ $t("message.delete") }}
                  </el-button>
                </div>
                <!-- 新增 -->
                <el-button size="mini" type="success" @click="add(index)">
                  {{ $t("message.add") }}
                </el-button>
              </div>
            </li>
            <!-- 操作 -->
            <li>
              <el-button type="primary" class="dark" @click="delList(index)">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="showCancelButton" @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 修改 -->
        <el-button type="primary" @click="refundsStore">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: { type: Array },
    showCancelButton: { type: Boolean, default: false },
  },
  data() {
    return {
      val: "",
      options: [
        { label: "退货", value: 1 },
        { label: "换货", value: 2 },
      ],
      dialogVisible: false
    };
  },
  created() {
    console.log(this.list);
    this.$forceUpdate();
  },
  methods: {
    // 追加物流单号
    add(i) {
      this.list[i].order_purchase_refund_detail_express.push({
        refund_express_no: "",
      });
      this.$forceUpdate();
    },
    // 删除物流单号
    delItem(index, indexs) {
      this.list[index].order_purchase_refund_detail_express.splice(indexs, 1);
      this.$forceUpdate();
    },
    // 退换货-添加
    refundsStore() {
      let datas = {
        refund_type: this.val,
        list: [],
      };
      this.list.forEach((item) => {
        let refund_express_no = [];
        item.order_purchase_refund_detail_express.forEach((items) => {
          refund_express_no.push(items.refund_express_no);
        });
        datas.list.push({
          order_purchase_id: item.order_purchase_id,
          num: item.num,
          refund_express_no: refund_express_no,
          problem_goods_id: item.problem_goods_id,
        });
      });
      this.$api.signInApi.refundsStore(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.problemList();
      });
    },

    //删除列表
    delList(i) {
      this.list.order_purchase_refund_detail.splice(i, 1);
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  .type {
    margin-bottom: 20px;

    span {
      margin-right: 20px;
    }
  }

  ul {
    padding: 24px 0;
  }

  li {
    margin-right: 24px;

    &:nth-last-child(1) {
      margin: 0;
    }
  }

  .flex15 {
    flex: 1.5;
  }

  .flex3 {
    flex: 3;

    .template {
      width: 100%;
    }

    .row {
      width: 100%;
      position: relative;
      margin-bottom: 10px;

      .el-button {
        position: absolute;
        top: 6px;
        right: 12px;
      }
    }
  }

  .flex05 {
    flex: 0.5;
  }
}
</style>